// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"108":"b8217c7c","164":"1e023884"}[chunkId] + ".js";
};